import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
} from 'react';
import { useOutletContext } from 'react-router';

import ProductCategoryList from '../../components/product-category-list/product-category-list';
import { isSelectionValid } from '../../utils/return-reasons';

export default function ExchangeProductSelectionView() {
  const {
    orderDetail,
    setPageTitle,
    setReady,
    selectedProducts,
    selectedProductComments,
    setSelectedProducts,
    setSelectedProductComments,
    setCarriers,
    setInvalidReturnReasons,
    showInvalidReturnReasons,
    setShowInvalidReturnReasons,
  } = useOutletContext();
  const viewport = useRef();

  useEffect(() => setPageTitle(''), []);
  useEffect(() => setReady(false), []);

  const orderItems = useMemo(() => {
    const { eligibleForReturn } = orderDetail.originalOrder;
    if (eligibleForReturn?.length) {
      return eligibleForReturn;
    }
    return orderDetail.originalOrder.orderItems;
  }, [orderDetail.originalOrder.eligibleForReturn, orderDetail.originalOrder.orderItems]);

  useEffect(() => {
    let error = 0;
    selectedProducts.forEach((product) => {
      const comments = selectedProductComments[product.orderLineKey];
      if (!comments) {
        error = 1;
      } else if (comments.reason1) {
        if (!isSelectionValid(
          orderDetail.returnReasons,
          product.bucket,
          comments.reason1.value,
          comments.reason2?.value,
          comments.reason3?.value,
        )) {
          error = 1;
        }
      } else if (!comments.exchangeReason) {
        error = 1;
      } else if (comments.exchangeReason.type === 'options' && !comments.exchangeSecondaryReason) {
        error = 1;
      }
    });

    setReady((selectedProducts.length > 0));
    const havingErrors = !!(selectedProducts.length > 0 && error);
    setInvalidReturnReasons(havingErrors);
    setCarriers(null);
    setShowInvalidReturnReasons(false);
  }, [selectedProducts, selectedProductComments]);

  const handleSelectedProduct = useCallback((orderLineKey, isChecked) => {
    const tmp = [...selectedProducts];

    if (isChecked) {
      const p = orderItems.find(
        (item) => item.orderLineKey === orderLineKey,
      );
      tmp.push(p);
    } else {
      const p = selectedProducts.find(
        (item) => item.orderLineKey === orderLineKey,
      );
      const idx = tmp.indexOf(p);
      tmp.splice(idx, 1);
    }

    setSelectedProducts(tmp);
  }, [orderItems, selectedProducts, setSelectedProducts]);

  const handleUpdateComments = useCallback((orderItemToken, comments) => {
    setSelectedProductComments((current) => ({
      ...current,
      [orderItemToken]: comments,
    }));
  }, [setSelectedProductComments]);

  return (
    <div className="exchange-product-selection-view" ref={viewport}>
      <ProductCategoryList
        category="DRE_SELECT_ITEMS_RETURN"
        orderItems={orderDetail.originalOrder.orderItems}
        products={orderDetail.originalOrder.eligibleForReturn}
        selectedProducts={selectedProducts}
        returnReasonCodeList={orderDetail.returnReasonCodeList}
        returnReasons={orderDetail.returnReasons}
        selectedProductComments={selectedProductComments}
        handleSelectedProduct={handleSelectedProduct}
        handleUpdateComments={handleUpdateComments}
        showEligible
        eligibility="eligible"
        isInValidReason={showInvalidReturnReasons}
      />

      <ProductCategoryList
        orderItems={orderDetail.originalOrder.orderItems}
        products={orderDetail.originalOrder.ineligibleForReturn}
        category="DRE_NOT_ELIGIBLE_FOR_RETURN"
        selectedProducts={selectedProducts}
        returnReasonCodeList={orderDetail.returnReasonCodeList}
        returnReasons={orderDetail.returnReasons}
        selectedProductComments={selectedProductComments}
        handleSelectedProduct={handleSelectedProduct}
        handleUpdateComments={handleUpdateComments}
        eligibility="ineligible"
      />
    </div>
  );
}
